import React from 'react';
import styles from './styles.module.css';
import { IBlogPost } from 'constants/types';
import { CardsMediumCarousel } from 'components/slider/embla-home/card';
import { CardsSkeleton } from 'components/slider/cards/medium';

export type Props = {
  posts: IBlogPost[];
  type?: 'blog-and-news' | 'guide';
};

export const NewsBlock = ({ posts, type }: Props) => {
  const OPTIONS = {
    align: 'start' as const,
    dragFree: false,
    startIndex: 0,
  };

  if (!posts?.length) {
    return <CardsSkeleton />;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Top {type === 'guide' ? 'Guides' : 'Blog and News'}
      </h2>
      <p className={styles.newsDescription}>
        The important casino news, every player should know this information.
      </p>
      <CardsMediumCarousel
        type={type}
        slides={posts?.length ? posts : []}
        //@ts-ignore
        options={OPTIONS}
      />
    </div>
  );
};
